import script from "./ChatReportsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatReportsList.vue?vue&type=script&setup=true&lang=js"

import "./ChatReportsList.vue?vue&type=style&index=0&id=33325e4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33325e4c"]])

export default __exports__